export const SET_INITIAL_PROJECT = 'SET_INITIAL_PROJECT';

export const FETCH_CURRENT_PROJECT_REQUEST = 'FETCH_CURRENT_PROJECT_REQUEST';
export const FETCH_CURRENT_PROJECT_SUCCESS = 'FETCH_CURRENT_PROJECT_SUCCESS';
export const FETCH_CURRENT_PROJECT_FAILURE = 'FETCH_CURRENT_PROJECT_FAILURE';

export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';

export const SET_CURRENT_PROJECT_REQUEST = 'SET_CURRENT_PROJECT_REQUEST';
export const SET_CURRENT_PROJECT_FAILURE = 'SET_CURRENT_PROJECT_FAILURE';
export const SET_CURRENT_PROJECT_SUCCESS = 'SET_CURRENT_PROJECT_SUCCESS';

export const SET_PROJECT_STRUCTURE = 'SET_PROJECT_STRUCTURE';

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE';

export const MOVE_PROJECT_RESOURCES_REQUEST = 'MOVE_PROJECT_RESOURCES_REQUEST';
export const MOVE_PROJECT_RESOURCES_SUCCESS = 'MOVE_PROJECT_RESOURCES_SUCCESS';
export const MOVE_PROJECT_RESOURCES_FAILURE = 'MOVE_PROJECT_RESOURCES_FAILURE';

export const DELETE_PROJECT_COLUMN_REQUEST = 'DELETE_PROJECT_COLUMN_REQUEST';
export const DELETE_PROJECT_COLUMN_SUCCESS = 'DELETE_PROJECT_COLUMN_SUCCESS';
export const DELETE_PROJECT_COLUMN_FAILURE = 'DELETE_PROJECT_COLUMN_FAILURE';

// Kanban
export const PING_PROJECT_KANBAN_REQUEST = 'PING_PROJECT_KANBAN_REQUEST';
export const PING_PROJECT_KANBAN_SUCCESS = 'PING_PROJECT_KANBAN_SUCCESS';
export const PING_PROJECT_KANBAN_FAILURE = 'PING_PROJECT_KANBAN_FAILURE';

export const SORT_KANBAN_REQUEST = 'SORT_KANBAN_REQUEST';
export const SORT_KANBAN_SUCCESS = 'SORT_KANBAN_SUCCESS';
export const SORT_KANBAN_FAILURE = 'SORT_KANBAN_FAILURE';

// Kanban Column
export const CREATE_SITE_CARD_COLUMN_REQUEST = 'CREATE_SITE_CARD_COLUMN_REQUEST';
export const CREATE_SITE_CARD_COLUMN_SUCCESS = 'CREATE_SITE_CARD_COLUMN_SUCCESS';
export const CREATE_SITE_CARD_COLUMN_FAILURE = 'CREATE_SITE_CARD_COLUMN_FAILURE';

export const UPDATE_SITE_CARD_COLUMN_REQUEST = 'UPDATE_SITE_CARD_COLUMN_REQUEST';
export const UPDATE_SITE_CARD_COLUMN_SUCCESS = 'UPDATE_SITE_CARD_COLUMN_SUCCESS';
export const UPDATE_SITE_CARD_COLUMN_FAILURE = 'UPDATE_SITE_CARD_COLUMN_FAILURE';

export const DELETE_SITE_CARD_COLUMN_REQUEST = 'DELETE_SITE_CARD_COLUMN_REQUEST';
export const DELETE_SITE_CARD_COLUMN_SUCCESS = 'DELETE_SITE_CARD_COLUMN_SUCCESS';
export const DELETE_SITE_CARD_COLUMN_FAILURE = 'DELETE_SITE_CARD_COLUMN_FAILURE';

export const MOVE_SITE_CARD_COLUMN_REQUEST = 'MOVE_SITE_CARD_COLUMN_REQUEST';
export const MOVE_SITE_CARD_COLUMN_SUCCESS = 'MOVE_SITE_CARD_COLUMN_SUCCESS';
export const MOVE_SITE_CARD_COLUMN_FAILURE = 'MOVE_SITE_CARD_COLUMN_FAILURE';

export const EXPORT_PROJECT_COLUMN_REQUEST = 'EXPORT_PROJECT_COLUMN_REQUEST';
export const EXPORT_PROJECT_COLUMN_SUCCESS = 'EXPORT_PROJECT_COLUMN_SUCCESS';
export const EXPORT_PROJECT_COLUMN_FAILURE = 'EXPORT_PROJECT_COLUMN_FAILURE';

export const COLUMN_SCROLL_POSITION_UPDATE = 'COLUMN_SCROLL_POSITION_UPDATE';
export const KANBAN_SCROLL_POSITION_UPDATE = 'KANBAN_SCROLL_POSITION_UPDATE';

// Kanban Site Card
export const MOVE_SITE_CARD_REQUEST = 'MOVE_SITE_CARD_REQUEST';
export const MOVE_SITE_CARD_SUCCESS = 'MOVE_SITE_CARD_SUCCESS';
export const MOVE_SITE_CARD_FAILURE = 'MOVE_SITE_CARD_FAILURE';

export const SORT_SITE_CARDS_REQUEST = 'SORT_SITE_CARDS_REQUEST';
export const SORT_SITE_CARDS_SUCCESS = 'SORT_SITE_CARDS_SUCCESS';
export const SORT_SITE_CARDS_FAILURE = 'SORT_SITE_CARDS_FAILURE';
